import { UploadFile, notify } from '../utils';
import { FormProvider, useForm } from 'react-hook-form';
import { ChangeStep } from '../redux/actions/StepperAction';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import docIcon from "../../image/doc.svg";
import Feather from "../../image/done.svg";
import UploadDocsRulesModal from './UploadDocsRulesModal';
import VideoCaptureModal from './VideoCaptureModal';
import { fillInfo } from '../../api/MoadianService';
import { useNavigate } from 'react-router-dom';

export default function UploadDocs() {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [recordedVideo, setRecordedVideo] = useState(null); // Will store video blob/URL
    const [videoBlob, setVideoBlob] = useState(null); // Will store video blob
    const [ekycCaptcha, setEkycCaptcha] = useState('لطفا خود را در ویدئویی نهایت ۱۰ ثانیه‌ای معرفی کنید'); // Will store captcha text
    const [showRulesModal, setShowRulesModal] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const dispatch = useDispatch();
    const methods = useForm();
    const navigate = useNavigate();
    // Get data from Redux
    const userFormData = useSelector(state => state.UserFormData);
    const firstInfo = useSelector(state => state.FirstInfo);
    const signInfo = useSelector(state => state.SignInfo);
    const tokenInfo = useSelector(state => state.Token);

    const onSubmit = methods.handleSubmit(async (data) => {
        // Validate that both images are uploaded
        if (!data.frontCardImage) {
            notify("لطفا تصویر جلوی کارت ملی را آپلود کنید");
            return;
        }
        if (!data.backCardImage) {
            notify("لطفا تصویر پشت کارت ملی را آپلود کنید");
            return;
        }
        if (!videoBlob) {
            notify("لطفا ویدئو را ضبط کنید");
            return;
        }
        if (!ekycCaptcha) {
            notify("خطا در دریافت اطلاعات ویدئو");
            return;
        }

        setIsSubmitted(true);
        
        try {
            // Convert base64 images to just the base64 string (remove data:image/... prefix)
            const frontCardBase64 = data.frontCardImage.includes(',') 
                ? data.frontCardImage.split(',')[1] 
                : data.frontCardImage;
            const backCardBase64 = data.backCardImage.includes(',') 
                ? data.backCardImage.split(',')[1] 
                : data.backCardImage;

            // Convert video blob to File
            // Determine file extension based on blob type
            const videoExtension = videoBlob.type.includes('mp4') ? 'mp4' : 'webm';
            const videoFileName = `testVideo.${videoExtension}`;
            const videoFile = new File([videoBlob], videoFileName, { 
                type: videoBlob.type || 'video/webm' 
            });

            // Prepare FormData
            const formData = new FormData();
            
            // Add string fields
            formData.append('signGateId',  '');
            formData.append('transactionId', tokenInfo.transactionId );
            formData.append('latinFirstName',  '');
            formData.append('nationalCode',  firstInfo.nationalId);
            formData.append('latinLastName', '');
            formData.append('birthDate',  '');
            formData.append('province',  '');
            formData.append('city',  '');
            formData.append('cardSerialNum','');
            formData.append('nationalCardImgBase64', frontCardBase64);
            formData.append('nationalCardBackImgBase64', backCardBase64);
            formData.append('ekycCaptcha', ekycCaptcha);
            
            // Add video file
            formData.append('testVideo', videoFile);

            // Send to API
            await fillInfo(formData);
            
            setIsSubmitted(false);
            // Navigate to success page
            dispatch(ChangeStep(6));
            navigate('/fill-done');
            
        } catch (error) {
            setIsSubmitted(false);
            notify(error?.response?.data?.message || 'خطا در ارسال اطلاعات');
        }
    });

    const handleRecordVideo = () => {
        setShowRulesModal(true);
    };

    const handleRulesConfirm = () => {
        setShowRulesModal(false);
        setShowVideoModal(true);
    };

    const handleVideoRecorded = (data) => {
        setRecordedVideo(data.videoUrl);
        setVideoBlob(data.videoBlob);
        setEkycCaptcha('لطفا خود را در ویدئویی نهایت ۱۰ ثانیه‌ای معرفی کنید');
        setShowVideoModal(false);
    };

    return (
        <div className='min-h-screen py-5' style={{ backgroundColor: '#f5f5f5' }}>
            <Toaster />
            <style>{`
                .upload-docs-container .testing .col-md-5 {
                    max-width: 100% !important;
                    flex: 0 0 100% !important;
                }
                .upload-docs-container .testing .d-flex {
                    width: 100% !important;
                }
                .upload-docs-container .testing .form-control {
                    flex: 1 !important;
                    min-width: 200px !important;
                }
                .upload-docs-container .testing .btn {
                    white-space: nowrap !important;
                    flex-shrink: 0 !important;
                }
                .upload-docs-container .testing .form-label {
                    display: block !important;
                    margin-bottom: 0.5rem !important;
                }
            `}</style>
            <div className='container mx-auto px-3 px-md-4 px-lg-5'>
                <div className='bg-white rounded-lg shadow-sm upload-docs-container' style={{ borderRadius: '10px', padding: '2rem' }}>
                    {/* Header Section */}
                    <div className='mb-5 pb-4' style={{ borderBottom: '1px solid #E5E5E5' }}>
                        <div className='d-flex align-items-center gap-3'>
                            <img src={docIcon} alt="مدارک" style={{ width: '48px', height: '48px' }} />
                            <div>
                                <h2 className='mb-1' style={{ 
                                    fontSize: '1.5rem', 
                                    fontWeight: '700', 
                                    color: '#131313',
                                    margin: 0 
                                }}>آپلود مدارک</h2>
                                <p className='mb-0' style={{ 
                                    fontSize: '0.9rem', 
                                    color: '#7B7B7B',
                                    margin: 0 
                                }}>لطفا تصاویر کارت ملی و ویدئو را آپلود کنید</p>
                            </div>
                        </div>
                    </div>

                    <FormProvider {...methods}>
                        <form onSubmit={e => e.preventDefault()} noValidate>
                            <div className='row justify-content-center mt-4'>
                                {/* Left Column - Card Images */}
                                <div className='col-12 col-lg-6 mb-4 mb-lg-0'>
                                    <div className='mb-4'>
                                        <UploadFile
                                            label_text="تصویر جلوی کارت ملی"
                                            name="frontCardImage"
                                            maxSizeMB={4}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: 'تصویر جلوی کارت ملی را آپلود کنید',
                                                },
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <UploadFile
                                            label_text="تصویر پشت کارت ملی"
                                            name="backCardImage"
                                            maxSizeMB={4}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: 'تصویر پشت کارت ملی را آپلود کنید',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Right Column - Video */}
                                <div className='col-12 col-lg-6'>
                                    <div className='mb-3'>
                                        <label className="form-label text-form-title mb-2">ویدئو</label>
                                        <span className='required-label'>*</span>
                                    </div>

                                    {recordedVideo ? (
                                        <div className='border rounded-lg p-3' style={{ 
                                            borderColor: '#D3D3D3', 
                                            borderRadius: '10px',
                                            backgroundColor: '#FAFAFA'
                                        }}>
                                            <video 
                                                src={recordedVideo} 
                                                controls 
                                                className='w-100 rounded mb-3'
                                                style={{ 
                                                    maxHeight: '280px',
                                                    borderRadius: '8px'
                                                }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setRecordedVideo(null);
                                                    setVideoBlob(null);
                                                    setEkycCaptcha('لطفا خود را در ویدئویی نهایت ۱۰ ثانیه‌ای معرفی کنید');
                                                }}
                                                className='btn w-100 d-flex align-items-center justify-content-center gap-2'
                                                style={{ 
                                                    backgroundColor: '#dc2626',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    padding: '0.5rem',
                                                    fontSize: '0.875rem',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M3 6h18"></path>
                                                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                                                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                                                </svg>
                                                حذف ویدئو
                                            </button>
                                        </div>
                                    ) : (
                                        <div className='border rounded-lg p-5 text-center' style={{ 
                                            border: '2px dashed #D3D3D3',
                                            borderRadius: '10px',
                                            backgroundColor: '#FAFAFA',
                                            minHeight: '280px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <div className='mb-4'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 44 35" fill="none" style={{ opacity: 0.4 }}>
                                                    <path d="M15.9539 12.445C20.1165 8.99386 26.2032 9.44483 29.5243 13.4505C30.3743 14.4756 30.9564 15.6314 31.2917 16.8408C31.3956 17.2156 31.9131 17.324 32.1303 17.0014C32.1938 16.9009 32.2765 16.8134 32.3735 16.7439C32.4706 16.6745 32.5799 16.6246 32.6951 16.5972C32.8102 16.5698 32.9289 16.5654 33.0441 16.5843C33.1592 16.6033 33.2685 16.6451 33.3654 16.7074C33.4623 16.7697 33.5449 16.8512 33.6083 16.947C33.6717 17.0428 33.7145 17.151 33.7343 17.2652C33.7542 17.3793 33.7505 17.4972 33.7237 17.6117C33.6968 17.7262 33.6472 17.835 33.5779 17.9318L31.7023 20.7174C31.3614 21.2237 30.6503 21.3091 30.1991 20.8979L27.851 18.7573C27.7596 18.6764 27.6874 18.5764 27.6392 18.464C27.591 18.3516 27.5678 18.2293 27.5714 18.1054C27.5749 17.9815 27.605 17.8588 27.6596 17.7454C27.7142 17.632 27.7921 17.5306 27.8882 17.4479C28.0556 17.3039 28.2685 17.2248 28.4857 17.2258C28.703 17.2268 28.9091 17.3078 29.0641 17.4533C29.2933 17.6622 29.637 17.4658 29.5461 17.1693C29.2649 16.2523 28.8057 15.3769 28.1519 14.5883C25.4217 11.2954 20.4708 10.9286 17.0489 13.7657L17.023 13.7871C16.6583 14.0895 16.1176 14.039 15.8152 13.6743C15.5128 13.3096 15.5634 12.7689 15.9281 12.4665L15.9539 12.445ZM12.2501 18.6999C12.591 18.1936 13.3021 18.1082 13.7533 18.5194L16.1014 20.66C16.1884 20.7348 16.2588 20.8268 16.3083 20.9305C16.3578 21.0342 16.3856 21.1475 16.3898 21.2637C16.394 21.3799 16.3747 21.4966 16.333 21.607C16.2913 21.7174 16.228 21.8192 16.1469 21.9063C16.0658 21.9935 15.9685 22.0643 15.8608 22.1145C15.7531 22.1648 15.6371 22.1934 15.5198 22.1988C15.4025 22.2042 15.2861 22.1862 15.1777 22.1458C15.0692 22.1055 14.9708 22.0437 14.8883 21.964C14.6591 21.7551 14.3154 21.9515 14.4063 22.2479C14.6875 23.165 15.1467 24.0404 15.8004 24.829C18.5306 28.1219 23.4815 28.4887 26.9035 25.6516L26.9294 25.6301C27.2941 25.3278 27.8348 25.3783 28.1372 25.743C28.4395 26.1077 28.389 26.6484 28.0243 26.9508L27.9985 26.9722C23.8359 30.4234 17.7491 29.9725 14.4281 25.9668C13.5781 24.9417 12.996 23.7859 12.6607 22.5765C12.5568 22.2017 12.0393 22.0933 11.8221 22.4159C11.7585 22.5164 11.6758 22.6039 11.5788 22.6733C11.4818 22.7428 11.3725 22.7927 11.2573 22.8201C11.1421 22.8475 11.0235 22.8519 10.9083 22.8329C10.7932 22.814 10.6839 22.7722 10.587 22.7099C10.4901 22.6476 10.4075 22.5661 10.3441 22.4703C10.2807 22.3745 10.2378 22.2663 10.218 22.1521C10.1982 22.0379 10.2019 21.9201 10.2287 21.8056C10.2556 21.6911 10.3052 21.5822 10.3745 21.4855L12.2501 18.6999Z" fill="#BCBCBC" />
                                                    <path d="M16.3598 0C15.3814 0 14.562 0.575658 14.0711 1.32401C14.0711 1.33481 14.0711 1.342 14.0711 1.3528L12.6301 3.68421H4.52083C2.03791 3.68421 0 5.76018 0 8.28947V30.3947C0 32.924 2.03791 35 4.52083 35H38.8792C41.3621 35 43.4 32.924 43.4 30.3947V8.28947C43.4 5.76018 41.3621 3.68421 38.8792 3.68421H30.6852L29.2441 1.3528C29.2441 1.342 29.2441 1.33481 29.2441 1.32401C28.7532 0.575658 27.9338 0 26.9555 0H16.3598ZM16.3598 1.84211H26.9555C27.2451 1.84211 27.4853 2.00401 27.7184 2.3602L29.4419 5.09457C29.6079 5.36081 29.894 5.52632 30.2048 5.52632H38.8792C40.3767 5.52632 41.5917 6.76398 41.5917 8.28947V30.3947C41.5917 31.9202 40.3767 33.1579 38.8792 33.1579H4.52083C3.02331 33.1579 1.80833 31.9202 1.80833 30.3947V8.28947C1.80833 6.76398 3.02331 5.52632 4.52083 5.52632H13.1104C13.4212 5.52632 13.7073 5.36081 13.8733 5.09457L15.5686 2.3602L15.5969 2.33141C15.8229 2.00761 16.0843 1.84211 16.3598 1.84211Z" fill="#BCBCBC" />
                                                </svg>
                                            </div>
                                            <p className='mb-4' style={{ color: '#7B7B7B', fontSize: '0.9rem' }}>ویدئو ضبط نشده است</p>
                                            <button
                                                type="button"
                                                onClick={handleRecordVideo}
                                                className='btn text-form-button d-flex align-items-center justify-content-center gap-2'
                                                style={{ padding: '0.5rem 1.5rem' }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40" fill="none" style={{ marginLeft: '0.5rem' }}>
                                                    <circle cx="20" cy="20" r="20" fill="#FF2B2B" />
                                                </svg>
                                                <span>ضبط ویدئو</span>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className='row justify-content-center mt-5 pt-4' style={{ borderTop: '1px solid #E5E5E5' }}>
                                <div className='col-12 col-md-10 col-lg-8 d-flex justify-content-center gap-3'>
                                    <button
                                        onClick={onSubmit}
                                        className='btn text-form-button d-flex align-items-center justify-content-center gap-2'
                                        style={{ padding: '0.75rem 2rem', minWidth: '180px' }}
                                    >
                                        <img src={Feather} alt="" style={{ width: '20px', height: '20px', marginLeft: '0.5rem' }} />
                                        <span>تایید و ادامه</span>
                                    </button>
                                    {/* <button
                                        onClick={() => dispatch(ChangeStep(1))}
                                        className='btn text-form-title d-flex align-items-center justify-content-center'
                                        style={{ 
                                            padding: '0.75rem 2rem', 
                                            minWidth: '180px',
                                            border: '2px solid #D3D3D3',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            color: '#131313'
                                        }}
                                    >
                                        بازگشت
                                    </button> */}
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </div>
            </div>

            {/* Loading Overlay */}
            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

            {/* Modals */}
            <UploadDocsRulesModal
                isOpen={showRulesModal}
                onClose={() => setShowRulesModal(false)}
                onConfirm={handleRulesConfirm}
            />

            <VideoCaptureModal
                isOpen={showVideoModal}
                onClose={() => setShowVideoModal(false)}
                onVideoRecorded={handleVideoRecorded}
            />
        </div>
    )
}

